import { connect } from 'react-redux';

import UpdateSession from './UpdateSession';
import { selectors, actionCreators } from '../../../dux/user';

const mapStateToProps = (state) => ({
  isAuthenticated: selectors.isAuthenticated(state),
  expirationDate: selectors.getTokenExpirationDate(state),
  startDate: selectors.getTokenStartDate(state),
});

const mapDispatchToProps = {
  updateSessionHandler: actionCreators.updateSession,
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateSession);
